import { Row } from 'antd';
import { Score } from './Score';
import { Summary } from './Summary';

export function SummaryInformation(): JSX.Element {
	return (
		<Row>
			<Summary />
			<Score />
		</Row>
	);
}
